import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from 'actions/utils';
import {
  ICommonResponse,
  ICommonResponseObject,
  IStudentAverageGrades,
  IStudentFinalGrades,
  ISubjectThemePerformance,
} from 'api/types';
import { IReducers } from 'reducers';
import genericReducers from 'reducers/genericReducer';
import { connectReducers } from 'utils';

import {
  GET_STUDENT_AVERAGE_GRADES,
  GET_STUDENT_FINAL_GRADES,
  GET_STUDENT_SUBJECT_THEMES,
  getStudentSubjectThemesActions,
  INVALIDATE_STUDENT_SUBJECT_THEMES_CACHE,
} from './actions';

export type StudentFinalGradesState = ICommonResponseObject<IStudentFinalGrades[]>;
export const studentFinalGrades = createReducer<IStudentFinalGrades[]>(GET_STUDENT_FINAL_GRADES, []);

export type StudentAverageGradesState = ICommonResponseObject<IStudentAverageGrades>;
export const studentAverageGrades = createReducer<IStudentAverageGrades>(GET_STUDENT_AVERAGE_GRADES, {
  averageMarkFive: 0,
  subjectsRank: [],
});

// student subject themes
export type StudentSubjectThemesState = ICommonResponseObject<ISubjectThemePerformance | null>;
const subjectThemesInitialState: StudentSubjectThemesState = {
  content: null,
  loading: false,
  requestCache: 'notCached',
};
const generic = genericReducers<StudentSubjectThemesState>();
export const studentSubjectThemes: IReducers<StudentSubjectThemesState> = {
  [GET_STUDENT_SUBJECT_THEMES[REQUEST]]: generic.get.request,
  [GET_STUDENT_SUBJECT_THEMES[SUCCESS]]: generic.get.success,
  [GET_STUDENT_SUBJECT_THEMES[FAILURE]]: generic.get.failure,
  [GET_STUDENT_SUBJECT_THEMES[INVALIDATE]]: generic.get.invalidate(subjectThemesInitialState),
};

// student subject themes cache
export type StudentSubjectThemesCacheState = Record<number, ISubjectThemePerformance>;
const subjectThemesCacheInitialState: StudentSubjectThemesCacheState = {};
export const studentSubjectThemesCache: IReducers<StudentSubjectThemesCacheState> = {
  [GET_STUDENT_SUBJECT_THEMES[SUCCESS]]: (state, action: ReturnType<typeof getStudentSubjectThemesActions.success>) => {
    const themePerformance = action.payload.data;
    const subjectId = themePerformance?.subjectId;

    if (!subjectId || themePerformance.theme.length === 0) {
      return state;
    }

    return {
      ...state,
      [subjectId]: themePerformance,
    };
  },
  [INVALIDATE_STUDENT_SUBJECT_THEMES_CACHE]: () => subjectThemesCacheInitialState,
};

export const collection = {
  studentFinalGrades,
  studentAverageGrades,
  studentSubjectThemes: connectReducers(subjectThemesInitialState, studentSubjectThemes),
  studentSubjectThemesCache: connectReducers(subjectThemesCacheInitialState, studentSubjectThemesCache),
};

function createReducer<DataType>(actions: Record<string, string>, initialContent: DataType) {
  const initialState: ICommonResponseObject<DataType> = {
    content: initialContent,
    loading: false,
    requestCache: 'notCached',
  };
  const generic = genericReducers<ICommonResponseObject<DataType>>();
  const reducer: IReducers<ICommonResponseObject<DataType>> = {
    [actions[REQUEST]]: generic.get.request,
    [actions[SUCCESS]]: generic.get.success,
    [actions[FAILURE]]: generic.get.failure,
    [actions[INVALIDATE]]: generic.get.invalidate(initialState),
  };

  return connectReducers(initialState, reducer);
}
